const BACKEND_DOMAIN = process.env.NEXT_PUBLIC_BACKEND_DOMAIN
const BACKEND_URL = `https://${process.env.NEXT_PUBLIC_BACKEND_DOMAIN}`

const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL

const WHITELISTED_COUNTRIES = process.env.NEXT_PUBLIC_WHITELISTED_COUNTRIES
  ? process.env.NEXT_PUBLIC_WHITELISTED_COUNTRIES.split(',').map(c => c.trim())
  : ['SA', 'KE'] // ie: Saudi Arabia, Kenya

const constants = {
  BASE_URL,
  BACKEND_DOMAIN,
  BACKEND_URL: BACKEND_URL + '/api/user-web-booking/v1',
  hCAPTCHA_SECRET_KEY: process.env.HCAPTCHA_SECRET_KEY || '',
  hCAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_HCAPTCHA_SITE_KEY || '',
  IPINFO_TOKEN: process.env.NEXT_PUBLIC_IPINFO_TOKEN,
  WHITELISTED_COUNTRIES
}

export default constants
